<div class="container">
  <ng-content></ng-content>
</div>
<div class="footer">
  <div class="footer-content">
    <span>
      Copyright © 2026 Alegra Learning
    </span>
    <a href="https://joyschoolenglish.com/privacy-policy" class="footer-link">privacy policy</a>
    <app-version-number></app-version-number>
  </div>
</div>